const getters = {
    curatedBox(state) {
        return state.curatedBox;
    },
    cart(state){
        return state.cart;
    },
    minQty(state){
        return state.minQty;
    }
};

export default getters;
